import type { ReactNode, SVGProps } from "react";

export function InternalTransferIcon(props: SVGProps<SVGSVGElement>): ReactNode {
	return (
		<svg
			fill="none"
			height="16"
			viewBox="-1.9 -1.9 17 17"
			width="16"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M9.6001 0.600098H12.6001V3.60004"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.2"
			/>
			<path
				d="M8.8501 4.35003L12.6001 0.600098"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.2"
			/>
			<path
				d="M0.600098 12.6L4.3501 8.8501"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.2"
			/>
			<path
				d="M9.6001 12.6H12.6001V9.6001"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.2"
			/>
			<path
				d="M0.600098 0.600098L12.6001 12.5999"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.2"
			/>
		</svg>
	);
}
